import React, {useState} from "react"
import {Link} from "react-router-dom"
import {useForm} from "react-hook-form"
import {
    Alert,
    AlertIcon,
    Button,
    ButtonGroup,
    FormControl,
    FormLabel,
    IconButton,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from "@chakra-ui/react"
import {PlusSmallIcon} from "@heroicons/react/20/solid"


import {ILabel, ILabelSet} from "@backend/types"
import {FIconColorPicker, FormInput, FTextArea} from "@components/form"
import {Table} from "@components/elements"
import LabelUpload, {labelHeaders, PickedLabel} from "@modules/label/components/LabelUpload"
import {labelSetApiCalls} from "@modules/label/service"
import {FieldType} from "@components/types"
import {IconNameExt} from "@utils/icons"

const fields: FieldType = {
    icon: {
        field: "icon",
        label: "Icon",
        rules: {
            required: "Label icon is required"
        }
    },
    color: {
        field: "color",
        label: "Color",
        rules: {
            required: "Label color is required"
        }
    },
    title: {
        field: "title",
        label: "Title of Label Set",
        rules: {
            required: "Label title is required"
        }
    },
    definition: {
        field: "definition",
        label: "Description of Label Set",
        rules: {
            required: "Label definition is required"
        }
    }
}

type LabelSetFormProps = {
    labelSet?: ILabelSet,
    onFinish: () => void
}

export function LabelSetForm({labelSet, onFinish}: LabelSetFormProps) {
    const {isOpen, onOpen, onClose, onToggle} = useDisclosure()
    const [labels, setLabels] = useState<PickedLabel[] | null>(labelSet?.labelIds as ILabel[])

    const {
        handleSubmit,
        register,
        setValue,
        watch,
        setError,
        clearErrors,
        formState: {errors, isSubmitting},
    } = useForm({defaultValues: labelSet})

    async function onSubmit(values) {

        if (!labels || !labels.length) {
            const message = "Please add labels"
            // @ts-ignore
            setError("input", {
                type: "manual",
                message,
            })
            return
        }

        try {
            const labelSetData: ILabelSet = {
                ...values
            }
            debugger
            // @ts-ignore
            labelSetData.labels = labels
            debugger
            if (labelSet?._id) {
                await labelSetApiCalls.apiCalls.update(labelSet?._id, labelSetData)
            } else
                await labelSetApiCalls.apiCalls.create(labelSetData)

            onFinish()

        } catch (err) {
            console.error(err)
        }
    }

    function onLabelsChange(selectedLabels: PickedLabel[]) {
        // @ts-ignore
        clearErrors("input")
        setLabels((prevState) => ([...(selectedLabels || []), ...(prevState || [])]))
    }

    function onLabelRemoveClick(labelId: string) {
        const filteredLabels = labels.filter(x => x._id !== labelId)
        setLabels(filteredLabels)
    }

    // @ts-ignore
    const watchValues: [IconNameExt, string] = watch(["icon", "color"])

    return <div>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="space-y-12">
                <div className="grid grid-cols-6 gap-3">
                    <div className="col-span-1 flex items-end space-x-4">
                        <FIconColorPicker
                            register={register}
                            errors={errors}
                            icon={{
                                ...fields.icon,
                                setValue,
                                value: watchValues[0]
                            }}
                            color={{
                                ...fields.color,
                                setValue,
                                value: watchValues[1]
                            }}
                        />
                        {/*<Avatar*/}
                        {/*    bg={watchValues[1]}*/}
                        {/*    className="mr-4"*/}
                        {/*    icon={<CatIcon icon={watchValues[0] || "blender"} iconSize="lg"/>}/>*/}
                        {/*<FMenu*/}
                        {/*    register={register}*/}
                        {/*    options={iconList}*/}
                        {/*    errors={errors}*/}
                        {/*    setValue={setValue}*/}
                        {/*    value={watchValues[0]}*/}
                        {/*    {...fields.icon}*/}
                        {/*/>*/}
                        {/*<FMenu*/}
                        {/*    register={register}*/}
                        {/*    options={colorList}*/}
                        {/*    errors={errors}*/}
                        {/*    setValue={setValue}*/}
                        {/*    value={watchValues[1]}*/}
                        {/*    {...fields.color}*/}
                        {/*/>*/}
                    </div>
                    <div className="col-span-5">
                        <FormInput register={register} errors={errors} {...fields.title}/>
                    </div>

                    <div className="col-span-full">
                        <FTextArea register={register} errors={errors} {...fields.definition}/>
                    </div>
                    <div className="col-span-full">
                        {labels ?
                            <div>
                                <FormControl display="flex" justifyContent="space-between" alignItems="center"
                                             mb={2}>
                                    <FormLabel mb={0}>Labels</FormLabel>
                                    <IconButton
                                        aria-label="Add more labels"
                                        onClick={onToggle}
                                        icon={<PlusSmallIcon className="h-5 w-5" aria-hidden="true"/>}
                                    />
                                </FormControl>
                                {!labels || labels.length === 0 ?
                                    <p className=" text-sm text-gray-500">No Labels Here.</p> :
                                    <Table
                                        caption={`Total ${labels.length} labels`}
                                        columns={[
                                            ...Object.keys(labelHeaders).filter(x => !labelHeaders[x].hidden).map(key => ({
                                                header: labelHeaders[key].title,
                                                accessorKey: key,
                                                enableColumnFilter: false,
                                                enableSorting: false
                                            })),
                                            {
                                                id: "select-button",
                                                cell: ({row: {original}}) => <span>
                                                <Button
                                                    colorScheme="red"
                                                    variant="ghost"
                                                    size="sm"
                                                    onClick={onLabelRemoveClick.bind(null, original._id)}
                                                >Remove</Button>
                                            </span>
                                            }
                                        ]}
                                        data={labels || []}
                                    />}
                            </div>
                            :
                            <LabelUpload
                                register={register}
                                errors={errors}
                                labels={labels}
                                onLabelsChange={onLabelsChange}
                            />
                        }
                    </div>

                </div>
            </div>
            <div className="mt-6 py-6 flex flex-col gap-y-6 border-t">
                {Object.keys(errors).length > 0 &&
                  <Alert status="error">
                    <AlertIcon/>
                    <ul>
                        {Object.values(errors).map((x, i) =>
                            <li key={i}>{x.message as string}</li>)}
                    </ul>
                  </Alert>}
                <div className="flex items-center justify-end">
                    <ButtonGroup variant="outline" spacing="6">
                        <Link to="../">
                            <Button>Cancel</Button>
                        </Link>
                        <Button type="submit" isLoading={isSubmitting} colorScheme="blue">Save</Button>
                    </ButtonGroup>
                </div>

            </div>
        </form>
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Add Labels</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <LabelUpload
                        register={register}
                        errors={errors}
                        labels={labels}
                        onLabelsChange={onLabelsChange}
                    />
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </div>
}